import ModalWrapper from 'dashboard/components/ModalWrapper';
import LoadingIndicator from 'dashboard/components-lib/LoadingIndicator';
import FormSelectList, { FormSelectListData } from 'dashboard/forms/FormSelectList';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { parseLabelFromNodeId } from 'dashboard/lib/utils/graph';
import { DatumTypeToken, NodeId } from 'dashboard/models/graph';
import { List } from 'dashboard/models/list';
import {
  BROWSER_FINGERPRINT_DATUM_TYPE,
  DEVICE_FINGERPRINT_BROWSER_DATUM_TYPE,
  EMAIL_DATUM_TYPE,
  GOVERNMENT_ID_DATUM_TYPE,
  NAME_DATUM_TYPE,
  NETWORK_DATUM_TYPE,
  PHONE_NUMBER_DATUM_TYPE,
} from 'lib/constants/graph';
import { ApiModel } from 'lib/interfaces/api';

interface AddToListModalProp {
  nodeId: NodeId;
  isModalShown: boolean;
  lists: List[];
  loadingLists: boolean;
  hideModal: () => void;
  handleAddToListAndClose: (
    listId: string,
    datumTypeToken: DatumTypeToken,
    listItemValue: string,
    idClass?: string,
  ) => void;
}

const AddToListModal = ({
  nodeId,
  lists,
  loadingLists,
  isModalShown,
  hideModal,
  handleAddToListAndClose,
}: AddToListModalProp) => {
  const DATUM_TYPE_TO_LIST_TYPE: Record<DatumTypeToken, string> = {
    [GOVERNMENT_ID_DATUM_TYPE.token]: ApiModel.ListGovernmentIdNumber,
    [NETWORK_DATUM_TYPE.token]: ApiModel.ListIpAddress,
    [NAME_DATUM_TYPE.token]: ApiModel.ListName,
    [PHONE_NUMBER_DATUM_TYPE.token]: ApiModel.ListPhoneNumber,
    [EMAIL_DATUM_TYPE.token]: ApiModel.ListEmailAddress,
    [BROWSER_FINGERPRINT_DATUM_TYPE.token]: ApiModel.ListBrowserFingerprint,
    [DEVICE_FINGERPRINT_BROWSER_DATUM_TYPE.token]: ApiModel.ListDeviceFingerprint,
  };

  const filteredLists = lists.filter(
    (list: List) => list.type === DATUM_TYPE_TO_LIST_TYPE[nodeId?.token],
  );

  const handleSubmit = (data: FormSelectListData) => {
    handleAddToListAndClose(data.selectedList, nodeId?.token, nodeId?.value);
  };
  return (
    <ModalWrapper
      isOpen={isModalShown}
      handleCloseModal={hideModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <ModalContainer size='lg'>
        <ModalHeader onClose={hideModal}>{`Add ${parseLabelFromNodeId(
          nodeId,
        )} to List`}</ModalHeader>

        {loadingLists ? (
          <LoadingIndicator />
        ) : (
          <ModalBody>
            <FormSelectList lists={filteredLists} handleClose={hideModal} onSubmit={handleSubmit} />
          </ModalBody>
        )}
      </ModalContainer>
    </ModalWrapper>
  );
};

export default AddToListModal;
